module.exports = __webpack_public_path__ + "img/blue-shadow.865dfa3a.png";